import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import { Link } from "react-router-dom";
import SouthAmerica from "../Components/assets/img/Blogs/SouthAmerica/SouthAmerica.jpg";
import Russia from "../Components/assets/img/Blogs/Russia/Moscow.jpg";
import NorthAmerica from "../Components/assets/img/Blogs/NorthAmerica/NewYorkCity.jpg";
import EastAsia from "../Components/assets/img/Blogs/EastAsia/EastAsia.jpg";
import CapeTown from "../Components/assets/img/Blogs/Africa/CapeTown.jpg";
import Thumbnail from "../Components/assets/img/Blogs/TopTenTipsBookingFlights/Thumbnail.png";
import PerfectEuropeanVacationOnBudgetThumbnail from "../Components/assets/img/Blogs/PerfectEuropeanVacationOnBudget/PerfectEuropeanVacationOnBudgetThumbnail.png";
import EssentialTravelChecklistThumbnail from "../Components/assets/img/Blogs/EssentialTravelChecklistInternationalTrips/EssentialTravelChecklistThumbnail.png";
import AvoidHiddenFeesWhenBookingFlightsHotels from "../Components/assets/img/Blogs/AvoidHiddenFeesWhenBookingFlightsHotels/AvoidHiddenFeesWhenBookingFlightsHotels.png";
import UltimateGuideBookingLastMinuteFlights from "../Components/assets/img/Blogs/UltimateGuideBookingLastMinuteFlights/UltimateGuideBookingLastMinuteFlights.png";
import TopTenCheapestCountries from "../Components/assets/img/Blogs/TopTenCheapestCountries/TopTenCheapestCountries.png";
import DirectVsConnectingFlights from "../Components/assets/img/Blogs/DirectvsConnectingFlights/Thumbnail.png";
import BookInternationalFlightsFaster from "../Components/assets/img/Blogs/BookInternationalFlightsFaster/Thumbnail.png";
import BestFlightRoutesfromUKtoIndia from "../Components/assets/img/Blogs/BestFlightRoutesfromUKtoIndia/BestFlightRoutesfromUKtoIndia.png";
import directNonstopConnectingflights from "../Components/assets/img/Blogs/directNonstopConnectingflights/directNonstopConnectingflights.png";

const Blogs = () => {
  return (
    <>
      <Header></Header>
      <div className="mainContent blogWrap">
        <div className="blogPageWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2>Blog & News</h2>
              </div>
            </div>
          </div>
        </div>
        <div className="blogListWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-4">
                <div className="itemWrap">
                  <Link to={"/DirectNonstopConnectingflights"}>
                    <div className="imgWrap">
                      <img
                        src={directNonstopConnectingflights}
                        className="img-fluid"
                        alt=""
                      />
                      <div className="imgTxt">
                        <h2>direct, non-stop, and connecting flights</h2>
                      </div>
                    </div>
                    <div className="dataWrap">
                      <h2>
                        Difference Between Direct, Non-Stop & Connecting Flights
                      </h2>
                      <p>
                        When booking flight tickets, you’ll often see terms like
                        non-stop, direct, and connecting flights. While they
                        sound similar, they’re not the same.....
                      </p>
                    </div>
                  </Link>
                </div>
              </div>

              <div className="col-md-4">
                <div className="itemWrap">
                  <Link to={"/BestFlightRoutesfromUKtoIndia"}>
                    <div className="imgWrap">
                      <img
                        src={BestFlightRoutesfromUKtoIndia}
                        className="img-fluid"
                        alt=""
                      />
                      <div className="imgTxt">
                        <h2>best UK–India flight routes in 2026</h2>
                      </div>
                    </div>
                    <div className="dataWrap">
                      <h2>Best Flight Routes from the UK to India in 2026</h2>
                      <p>
                        International travel between the UK and India continues
                        to grow in 2026, with more travellers looking for
                        reliable routes, transparent pricing, and smooth booking
                        experiences.....
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
               <div className="col-md-4">
                <div className="itemWrap">
                  <Link to={"/BookInternationalFlightsFaster"}>
                    <div className="imgWrap">
                      <img
                        src={BookInternationalFlightsFaster}
                        className="img-fluid"
                        alt=""
                      />
                      <div className="imgTxt">
                        <h2>Book International Flights Faster</h2>
                      </div>
                    </div>
                    <div className="dataWrap">
                      <h2>
                        How to Book International Flights Faster Without
                        Compromising on Price
                      </h2>
                      <p>
                        Booking international flights doesn’t have to be
                        time-consuming or expensive. Many travelers spend hours
                        comparing prices across multiple websites....
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-md-4">
                <div className="itemWrap">
                  <Link to={"/DirectVsConnectingFlights"}>
                    <div className="imgWrap">
                      <img
                        src={DirectVsConnectingFlights}
                        className="img-fluid"
                        alt=""
                      />
                      <div className="imgTxt">
                        <h2>Direct vs Connecting Flights</h2>
                      </div>
                    </div>
                    <div className="dataWrap">
                      <h2>
                        Direct vs Connecting Flights: Which One Should You
                        Choose?
                      </h2>
                      <p>
                        Booking an international flight often comes down to one
                        important decision: direct or connecting? Both options
                        have their advantages, and the right choice depends on
                        your priorities — time, budget, comfort, and
                        flexibility....
                      </p>
                    </div>
                  </Link>
                </div>
              </div>

              <div className="col-md-4">
                <div className="itemWrap">
                  <Link to={"/TopTenCheapestCountries"}>
                    <div className="imgWrap">
                      <img
                        src={TopTenCheapestCountries}
                        className="img-fluid"
                        alt=""
                      />
                      <div className="imgTxt">
                        <h2>Budget Travel in 2026 with Travasco</h2>
                      </div>
                    </div>
                    <div className="dataWrap">
                      <h2>
                        Top 10 Cheapest Countries to Visit in 2026 — Budget
                        Travel Made Easy with Travasco
                      </h2>
                      <p>
                        Travel in 2026 is more exciting than ever, and budget
                        travellers are looking for destinations that offer
                        incredible experiences without high costs....
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-md-4">
                <div className="itemWrap">
                  <Link to={"/UltimateGuideBookingLastMinuteFlights"}>
                    <div className="imgWrap">
                      <img
                        src={UltimateGuideBookingLastMinuteFlights}
                        className="img-fluid"
                        alt=""
                      />
                      <div className="imgTxt">
                        <h2>Booking Last-Minute Flights in 2025</h2>
                      </div>
                    </div>
                    <div className="dataWrap">
                      <h2>
                        The Ultimate Guide to Booking Last-Minute Flights in
                        2025
                      </h2>
                      <p>
                        Last‑minute trips are stressful for most people—but at
                        Travasco, they are just another day of smart planning,
                        real‑time fares, and fast booking support....
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-md-4">
                <div className="itemWrap">
                  <Link to={"/AvoidHiddenFeesWhenBookingFlightsHotels"}>
                    <div className="imgWrap">
                      <img
                        src={AvoidHiddenFeesWhenBookingFlightsHotels}
                        className="img-fluid"
                        alt=""
                      />
                      <div className="imgTxt">
                        <h2>Booking Flights and Hotels in 2025</h2>
                      </div>
                    </div>
                    <div className="dataWrap">
                      <h2>
                        How to Avoid Hidden Fees When Booking Flights and Hotels
                        in 2025
                      </h2>
                      <p>
                        Booking flights and hotels online can sometimes come
                        with unexpected hidden fees that inflate...
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-md-4">
                <div className="itemWrap">
                  <Link to={"/EssentialTravelChecklistInternationalTrips"}>
                    <div className="imgWrap">
                      <img
                        src={EssentialTravelChecklistThumbnail}
                        className="img-fluid"
                        alt=""
                      />
                      <div className="imgTxt">
                        <h2>International Trips in 2025</h2>
                      </div>
                    </div>
                    <div className="dataWrap">
                      <h2>
                        Essential Travel Checklist: What to Pack for
                        International Trips in 2025
                      </h2>
                      <p>
                        Booking cheap flights online can save you a significant
                        amount on your travel expenses...
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-md-4">
                <div className="itemWrap">
                  <Link to={"/PerfectEuropeanVacationOnBudget"}>
                    <div className="imgWrap">
                      <img
                        src={PerfectEuropeanVacationOnBudgetThumbnail}
                        className="img-fluid"
                        alt=""
                      />
                      <div className="imgTxt">
                        <h2>European Vacation in 2025 </h2>
                      </div>
                    </div>
                    <div className="dataWrap">
                      <h2>
                        How to Plan Your Perfect European Vacation on a Budget
                        in 2025
                      </h2>
                      <p>
                        Europe offers incredible history, stunning landscapes,
                        diverse cultures, and world-class cuisine—all waiting to
                        be...
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-md-4">
                <div className="itemWrap">
                  <Link to={"/TopTenTipsBookingFlights"}>
                    <div className="imgWrap">
                      <img src={Thumbnail} className="img-fluid" alt="" />
                      <div className="imgTxt">
                        <h2>Flights Online in 2025 </h2>
                      </div>
                    </div>
                    <div className="dataWrap">
                      <h2>
                        Top 10 Tips for Booking Cheap Flights Online in 2025
                      </h2>
                      <p>
                        Jumping between ten tabs to compare prices is
                        exhausting. Travasco’s approach is to centralize flight
                        options from multiple sources...
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-md-4">
                <div className="itemWrap">
                  <Link to={"/SouthAmerica"}>
                    <div className="imgWrap">
                      <img src={SouthAmerica} className="img-fluid" alt="" />
                      <div className="imgTxt">
                        <h2>South America</h2>
                      </div>
                    </div>
                    <div className="dataWrap">
                      <h2>South America</h2>
                      <p>
                        South America is a continent of breathtaking landscapes,
                        ancient civilizations, vibrant cities, and diverse
                        cultures.
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-md-4">
                <div className="itemWrap">
                  <Link to={"/Russia"}>
                    <div className="imgWrap">
                      <img src={Russia} className="img-fluid" alt="" />
                      <div className="imgTxt">
                        <h2>Russia</h2>
                      </div>
                    </div>
                    <div className="dataWrap">
                      <h2>Russia</h2>
                      <p>
                        Russia, the world’s largest country, spans two
                        continents and offers a dramatic blend of imperial
                        cities, ancient traditions...
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-md-4">
                <div className="itemWrap">
                  <Link to={"/NorthAmerica"}>
                    <div className="imgWrap">
                      <img src={NorthAmerica} className="img-fluid" alt="" />
                      <div className="imgTxt">
                        <h2>North America </h2>
                      </div>
                    </div>
                    <div className="dataWrap">
                      <h2>North America </h2>
                      <p>
                        North America is a continent full of contrasts—towering
                        mountains, iconic cities, ancient wonders, and vast
                        natural parks.
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-md-4">
                <div className="itemWrap">
                  <Link to={"/EastAsia"}>
                    <div className="imgWrap">
                      <img src={EastAsia} className="img-fluid" alt="" />
                      <div className="imgTxt">
                        <h2>East Asia</h2>
                      </div>
                    </div>
                    <div className="dataWrap">
                      <h2>East Asia</h2>
                      <p>
                        East Asia offers a rich mix of ancient traditions,
                        futuristic cities, and natural wonders. From imperial
                        palaces to neon-lit skylines and serene temples...
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-md-4">
                <div className="itemWrap">
                  <Link to={"/Africa"}>
                    <div className="imgWrap">
                      <img src={CapeTown} className="img-fluid" alt="" />
                      <div className="imgTxt">
                        <h2>Africa</h2>
                      </div>
                    </div>
                    <div className="dataWrap">
                      <h2>Africa</h2>
                      <p>
                        Africa is a continent of stunning contrasts, rich
                        cultures, and unparalleled natural beauty. From golden
                        deserts to lush jungles and world-renowned wildlife...
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer></Footer>
    </>
  );
};
export default Blogs;
